import axios from "axios";

export default
  data =>
    axios
      .post(
        `/v2/authentication/confirm`,
        data
      )
      .then(({ data }) => data);
